import type { Guide, GuideRecordHint } from '../types';

/**
 * S-21.10-16 — CS lekko: awizacje i notatki przy zleceniu (sekcja 7), kolejka CS (scenariusz e2e 20, krok 20.5
 * i 20.6; BR-CS-10, BR-CS-11). Zlecenie DEMO/2026/10/A01 (`seed-e2e.ts`); w kolejce CS są prezlecenia u CS
 * z `scenario-state.mjs` (m.in. C1).
 */
const ORDER: GuideRecordHint = {
  description: 'dowolne zlecenie',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide' },
};

export const guide: Guide = {
  flagKey: 'csLight',
  title: 'CS lekko: awizacje i notatki przy zleceniu, kolejka CS',
  whatItDoes:
    'W oknie zlecenia, w sekcji 7 „Komunikacja z klientem”, CS wpisuje wynik awizacji — kanał (telefon, mail, platforma), wynik (potwierdzono termin, prośba o zmianę terminu, brak kontaktu, inny) i notatkę — albo samą notatkę; kto i kiedy zapisuje się samo, a wpis trafia też do historii zlecenia. Z aplikacji nic nie jest wysyłane, a wpisy widzą także planiści i Trade. Nowa „Kolejka CS” zbiera sprawy CS — prezlecenia do uzupełnienia i zwrócone z pytaniem, otwarte uwagi od FTL i zmiany zleceń do decyzji CS — według terminu załadunku i krytyczności, z filtrami. Dotąd sekcja 7 była pusta, a kolejki nie było.',
  audience: ['CS', 'planista FTL (podgląd)', 'Trade (podgląd)'],
  presentationItems: ['S-21.10-16'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: ORDER,
      target: 'client-contact-log',
      mockupTestId: 'cs-awizacje-wiersz-{id}',
      title: 'Wynik awizacji w sekcji 7',
      description:
        'CS wybiera kanał i wynik awizacji, dopisuje notatkę i zapisuje przy zleceniu — albo dodaje samą notatkę. Z systemu nic nie wychodzi: zapisujesz, co ustaliłeś z klientem.',
      action: 'Rozwiń sekcję 7 „Komunikacja z klientem”, wybierz kanał i wynik, wpisz notatkę i kliknij „Zapisz przy zleceniu”.',
      recorder: {
        account: 'cs',
        demo: { kind: 'order', number: 'DEMO/2026/10/A01' },
        actions: [
          { kind: 'expand', target: 'order-section-communication' },
          { kind: 'select', label: 'Kanał', option: 'telefon' },
          { kind: 'select', label: 'Wynik', option: 'potwierdzono termin' },
          { kind: 'fill', target: 'client-contact-text', value: 'Termin potwierdzony z magazynem klienta.' },
        ],
      },
    },
    {
      route: '/cs-queue',
      target: 'cs-skrzynka-wiersz-*',
      mockupTestId: 'cs-skrzynka-wiersz-{id}',
      title: 'Kolejka CS',
      description:
        'Jedna lista spraw CS: prezlecenia do uzupełnienia i zwrócone z pytaniem, otwarte uwagi od FTL i zmiany zleceń do decyzji CS. Na górze najbliższy termin załadunku; pilne — termin w ciągu 24 h, minął albo pilna uwaga FTL, wysokie — w ciągu 72 h albo zwrot z pytaniem (progi robocze).',
      action: 'Otwórz „Kolejka CS” w menu, zawęź listę filtrami (klient, lokalizacja, rodzaj sprawy, wykonawca) i kliknij sprawę.',
      recorder: { account: 'cs' },
    },
    {
      route: '/user-offers/:orderId/show',
      record: ORDER,
      target: 'client-contact-log',
      title: 'Planista i Trade widzą wpisy CS',
      description:
        'Wpisy CS są przy zleceniu dla każdego zalogowanego: planista FTL i Trade widzą wynik awizacji i notatki, bez formularza. Kolejka CS jest tylko dla CS.',
      action: 'Na karcie zlecenia rozwiń sekcję 7 „Komunikacja z klientem”.',
      recorder: {
        account: 'ftl',
        demo: { kind: 'order', number: 'DEMO/2026/10/A01' },
        actions: [{ kind: 'expand', target: 'order-section-communication' }],
      },
    },
  ],
};
